import { populate, register } from 'react-abode';
// @ts-expect-error TS2339: Property context does not exist on type NodeRequire
var blockJsons = require.context('../blocks', true, /block\.json/);
// @ts-expect-error TS2339: Property context does not exist on type NodeRequire
var components = require.context('./components', true, /abode\.tsx$/);
blockJsons.keys().forEach(function (key) {
    var folder = key.split('/')[1];
    var blockJson = blockJsons(key);
    var hasBlock = !!blockJson.__component__;
    if (!hasBlock)
        return;
    register(blockJson.__component__, function () { return import("../blocks/".concat(folder, "/block")); });
    populate().then();
});
components.keys().forEach(function (key) {
    var entry = components(key).default;
    var list = Array.isArray(entry) ? entry : [entry];
    list.forEach(function (component) {
        try {
            register(component.name, component.import);
            populate().then();
        }
        catch (_a) {
            // eslint-disable-next-line no-console
            console.error("Can not register component ".concat(component === null || component === void 0 ? void 0 : component.name, ". File not found."));
        }
    });
});
